import { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import Dashboard from "../pages/admin/Dashboard";
import Settings from "../pages/admin/Settings/Settings";

import { QuickBooksContext } from "../context/QuickBooksContext";
import QuickBooksAuthPage from "../pages/QuickBooksAuthPage";
import TimeCards from "../pages/admin/TimeCards";
import Employees from "../pages/admin/Employees/Employees";
import CreateEmployee from "../pages/admin/Employees/CreateEmployee";
import ShopView from "../pages/admin/ShopView";
import NewOrderDetail from "../pages/admin/Orders/OrderDetails/OrderDetailsPage";
import CreateOrder from "../pages/admin/CreateNewOrderPage";
import Error404 from "../pages/error/Error404";
import ColorDetails from "../components/SettingsComponents/Colors/ColorDetails";
import CreatePurchaseOrder from "../pages/admin/PurchaseOrders/CreatePurchaseOrder";
import PurchaseOrderDetails from "../pages/admin/PurchaseOrders/PurchaseOrderDetails";
import CreateNewOrderForCompany from "../pages/admin/CreateNewOrderForCompany";
import Customers from "../pages/admin/Customers/Customers";
import CustomerDetails from "../pages/admin/Customers/CustomerDetails";
import EditCustomerUser from "../pages/admin/Customers/EditCustomerUser";
import Sales from "../pages/admin/Sales/Sales";
import EmployeeDetails from "../pages/admin/Employees/EmployeeDetails";
import MasterTrimCatalog from "../pages/admin/MasterTrimCatalog/MasterTrimCatalog";
import SquareFootPricing from "../pages/admin/SquareFootPricing/SquareFootPricing";
import Orders from "../pages/admin/Orders/Orders";
import EditCustomerSettings from "../pages/admin/Customers/EditCustomerSettings";
import MasterTrimDetail from "../pages/admin/MasterTrimCatalog/MasterTrimDetail";
import PrintMasterTrimCatalog from "../pages/admin/MasterTrimCatalog/PrintMasterTrimCatalog";
import PrintCustomerStockTrimCatalog from "../pages/admin/Customers/PrintCustomerStockTrimCatalog";
import ShopSchedule from "../pages/admin/ShopSchedule/ShopSchedule";
import AdminColorCatalog from "../pages/admin/ColorCatalog/AdminColorCatalog";
import AdminPanelCatalog from "../pages/admin/PanelCatalog/AdminPanelCatalog";
import FsOptimizer from "../pages/admin/FsOptimizer/FsOptimizer";
import SentryTest from "../pages/admin/Sentry/SentryTest";
import PickupDetailsPage from "../pages/admin/ReadyForPickup/PickupDetails";
import NewPickupPage from "../pages/admin/ReadyForPickup/NewPickupPage";
import OrderPickupHistoryPage from "../pages/admin/ReadyForPickup/OrderPickupHistoryPage";
import ReadyForPickupPage from "../pages/admin/ReadyForPickup/ReadyForPickupPage";
import NewQuotePage from "../pages/admin/Quotes/NewQuote/NewQuotePage";
import QuoteRequestsPage from "../pages/admin/QuoteRequests/QuoteRequestsPage";
import InvoiceDetails from "../pages/admin/Invoices/InvoiceDetails";
import ReceiveCashOrCheckPayment from "../pages/admin/Invoices/ReceiveCashOrCheckPayment";
import EditQuotePage from "../pages/admin/Quotes/Quote/EditQuote/EditQuotePage";
import QuoteDetailsPage from "../pages/admin/Quotes/Quote/QuoteDetails/QuoteDetailsPage";
import NewJobPage from "../pages/admin/Jobs/NewJob/NewJobPage";
import InvoicesPage from "../pages/admin/Invoices/InvoicesPage";
import EditPickup from "../pages/admin/ReadyForPickup/EditPickup";
import PickupReviewAndSign from "../pages/admin/ReadyForPickup/PickupReviewAndSign";
import JobsPage from "../pages/admin/Jobs/JobsPage";
import ConsumablesPage from "../pages/admin/ConsumablesCatalog/ConsumablesPage";
import ConsumablesPosPage from "../pages/admin/ConsumablesPos/ConsumablesPosPage";
import NewSalesTicketPage from "../pages/admin/ConsumablesPos/NewSalesTicket/NewSalesTicketPage";
import SalesTicketPage from "../pages/admin/ConsumablesPos/SalesTicket/SalesTicketPage";
import TimeEntriesPage from "../pages/admin/Time/TimeEntriesPage";
import WeeklyTimeSummariesPage from "../pages/admin/Time/WeeklyTimeSummariesPage";
import WeeklyTimeSummaryPage from "../pages/admin/Time/WeeklyTimeSummaryPage";
import WorkStationsPage from "../pages/admin/WorkStations/WorkStationsPage";
import PurchaseOrdersPage from "../pages/admin/PurchaseOrders/PurchaseOrdersPage";
import EditEmployeeDetails from "../pages/admin/Employees/EditEmployeeDetails";
import TimeApprovalPage from "../pages/shop/Time/TimeApprovalPage";
import JobPickupsPage from "../pages/admin/JobPickups/JobPickupsPage";

const AdminRoutes = () => {
  const { role, authToken, companyId } = useContext(AuthContext);
  const { isQbAuthenticated } = useContext(QuickBooksContext);

  if (
    role === undefined ||
    authToken === undefined ||
    isQbAuthenticated === undefined
  ) {
    console.log(role, authToken, isQbAuthenticated);
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={isQbAuthenticated ? <Dashboard /> : <QuickBooksAuthPage />}
        >
          {/* Force QB Login Page */}
          <Route path="/qb" element={<QuickBooksAuthPage />} />
          <Route path="/callback" element={<QuickBooksAuthPage />} />
          <Route path="/sentry" element={<SentryTest />} />

          {/* New Quotes and Orders */}
          <Route path="/" element={<QuoteRequestsPage />} />
          <Route path="/quotes" element={<QuoteRequestsPage />} />
          <Route path="/quotes/create" element={<NewQuotePage />} />
          <Route path="/quotes/:quoteId/edit" element={<EditQuotePage />} />
          <Route path="/quotes/:quoteId" element={<QuoteDetailsPage />} />
          <Route path="/orders/:quoteId" element={<QuoteDetailsPage />} />
          {/* <Route path="/quotes/v2/:quoteId/edit" element={<EditQuotePage />} />
          <Route path="/quotes/v2/:quoteId" element={<QuoteDetailsPage />} />
          <Route path="/orders/v2/:quoteId" element={<QuoteDetailsPage />} /> */}

          {/* Old Quote & Order Version */}
          <Route path="/quotes/v1/:orderId" element={<NewOrderDetail />} />
          <Route path="/orders/v1/:orderId" element={<NewOrderDetail />} />
          {/* <Route path="/quotes/:orderId" element={<NewOrderDetail />} />
          <Route path="/orders/:orderId" element={<NewOrderDetail />} /> */}
          <Route
            path="/orders/active"
            element={<Orders resource="orders" activeTab="active" />}
          />
          <Route
            path="/orders/in-progress"
            element={<Orders resource="orders" activeTab="in-progress" />}
          />
          <Route
            path="/orders/ready"
            element={<Orders resource="orders" activeTab="ready" />}
          />
          <Route
            path="/orders/fulfilled"
            element={<Orders resource="orders" activeTab="fulfilled" />}
          />
          <Route
            path="/orders/unpaid"
            element={<Orders resource="orders" activeTab="unpaid" />}
          />
          <Route
            path="/orders"
            element={<Orders resource="orders" activeTab="active" />}
          />

          <Route
            path="/company/:companyId/projects/:projectId/orders/create"
            element={<CreateNewOrderForCompany />}
          />

          <Route path="/sales" element={<Sales />} />
          <Route path="/customers" element={<Customers />} />

          <Route path="/customers/:id" element={<CustomerDetails />} />
          <Route
            path="/customers/:companyId/company-settings"
            element={<EditCustomerSettings />}
          />
          <Route
            path="/customers/:companyId/users/:userId"
            element={<EditCustomerUser />}
          />

          <Route
            path="/shop-view/active"
            element={<ShopView resource="shop-view" activeTab="active" />}
          />
          <Route
            path="/shop-view/in-progress"
            element={<ShopView resource="shop-view" activeTab="in-progress" />}
          />
          <Route
            path="/shop-view/ready"
            element={<ShopView resource="shop-view" activeTab="ready" />}
          />
          <Route
            path="/shop-view"
            element={<ShopView resource="shop-view" activeTab="in-progress" />}
          />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/jobs/create" element={<NewJobPage />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/invoices/:orderId" element={<InvoiceDetails />} />
          <Route
            path="/invoices/:orderId/receive-payment"
            element={<ReceiveCashOrCheckPayment />}
          />
          <Route path="job-pickups" element={<JobPickupsPage />} />
          <Route
            path="job-pickups/:orderId"
            element={<OrderPickupHistoryPage />}
          />
          <Route
            path="job-pickups/:orderId/new-pickup"
            element={<NewPickupPage />}
          />
          <Route
            path="job-pickups/:orderId/pickups/:pickupId"
            element={<PickupDetailsPage />}
          />
          <Route
            path="job-pickups/:orderId/pickups/:pickupId/review"
            element={<PickupReviewAndSign />}
          />
          <Route
            path="job-pickups/:orderId/pickups/:pickupId/edit"
            element={<EditPickup />}
          />

          <Route path="/shop-schedule" element={<ShopSchedule />} />
          <Route path="/fs-optimizer" element={<FsOptimizer />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/employees/:id" element={<EmployeeDetails />} />
          <Route path="/employees/:id/edit" element={<EditEmployeeDetails />} />
          <Route path="/employees/new" element={<CreateEmployee />} />
          {/* <Route path="orders/create" element={<NewOrder />} /> */}

          <Route path="/settings" element={<Settings />} />
          <Route path="/panel-catalog" element={<AdminPanelCatalog />} />
          <Route path="/color-catalog" element={<AdminColorCatalog />} />
          <Route path="/color-catalog/:id" element={<ColorDetails />} />
          <Route path="/time-cards" element={<TimeCards />}></Route>

          <Route path="/consumables-catalog" element={<ConsumablesPage />} />
          <Route path="/consumables-pos" element={<ConsumablesPosPage />} />
          <Route path="/consumables-pos/:id" element={<SalesTicketPage />} />
          <Route
            path="/consumables-pos/new-sales-ticket"
            element={<NewSalesTicketPage />}
          />

          <Route
            path="/orders/:orderId/purchase-orders/new"
            element={<CreatePurchaseOrder />}
          />
          <Route path="/orders/create" element={<CreateOrder />} />
          <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
          <Route
            path="/purchase-orders/new"
            element={<CreatePurchaseOrder />}
          />
          <Route
            path="/purchase-orders/:id"
            element={<PurchaseOrderDetails />}
          />
          <Route path="/master-trim-catalog" element={<MasterTrimCatalog />} />
          <Route
            path="/master-trim-catalog/print"
            element={<PrintMasterTrimCatalog />}
          />
          <Route
            path="/customer/:companyId/trims/stock"
            element={<PrintCustomerStockTrimCatalog />}
          />
          <Route
            path="/master-trim-catalog/:id"
            element={<MasterTrimDetail />}
          />
          <Route path="/sf-pricing" element={<SquareFootPricing />} />

          {/* Time Entries */}
          <Route path="/time-entries" element={<TimeEntriesPage />} />
          <Route
            path="/weekly-time-summaries"
            element={<WeeklyTimeSummariesPage />}
          />
          <Route
            path="/weekly-time-summaries/:id"
            element={<WeeklyTimeSummaryPage />}
          />
          {/* No Auth Weekly Time Summary Signing Page */}
          <Route
            path="/weekly-time-summary/:weeklyTimeSummaryId"
            element={<TimeApprovalPage />}
          />

          <Route path="/work-stations" element={<WorkStationsPage />} />

          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
export default AdminRoutes;
